import { MessagesEnum, FormsEnum } from 'app/shared/enums';
import {
  getSecondCoownerData,
  getQuotation,
  getIsOperatorFromSelector,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';
import { handleObfuscatedFieldConsentReset } from 'app/services/businessFunctions/helpers/handleObfuscatedFieldConsentReset';
import {
  isPersonalDataRedesignActive,
  isPersonalDataTwoAdvantagesView,
} from 'app/shared/helpers/personalDataViewByDevice';

const secondCoownerObfuscation = {
  calculationShowCoowners2NameObfuscatedMessage(initialRun?: boolean) {
    const { name = '' } = getSecondCoownerData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: name,
      initialRun,
      messageKey: MessagesEnum.Coowners2NameObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      forceHideMessage: isPersonalDataRedesignActive(),
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner2',
        field: 'name',
      },
    });
  },
  calculationShowCoowners2LastNameObfuscatedMessage(initialRun?: boolean) {
    const { lastName = '' } = getSecondCoownerData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: lastName,
      initialRun,
      messageKey: MessagesEnum.Coowners2LastNameObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      forceHideMessage: isPersonalDataRedesignActive(),
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner2',
        field: 'lastName',
      },
    });
  },
  calculationShowCoowners2PeselObfuscatedMessage(initialRun?: boolean) {
    const pesel = `${getSecondCoownerData().pesel}`;
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: pesel,
      initialRun,
      messageKey: MessagesEnum.Coowners2PeselObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      forceHideMessage: isPersonalDataTwoAdvantagesView(),
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner2',
        field: 'peselNumber',
      },
    });
  },
  calculationShowCoowners2FamilyNameObfuscatedMessage(initialRun?: boolean) {
    const { familyName } = getSecondCoownerData();

    const showObfuscatedMessage = checkIsDataObfuscated(familyName, initialRun);

    setMessageVisibility({
      key: MessagesEnum.SecondCoownerFamilyNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CalculationForm,
    });
  },
};

export default secondCoownerObfuscation;
